import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  FileVideo,
  Briefcase,
  User,
  Download,
  Settings,
  X
} from 'lucide-react';
import { clsx } from 'clsx';
import { useAuth } from '../../contexts/AuthContext';

const navigation = [
  {
    name: 'Recent Projects',
    href: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'Templates',
    href: '/templates',
    icon: FileVideo,
  },
  {
    name: 'Profile',
    href: '/profile',
    icon: User,
  },
];

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { user } = useAuth();

  // Check if user is admin
  const isAdmin = user?.role === 'admin';

  // Add admin-only navigation items
  const adminNavigation = isAdmin ? [
    {
      name: 'Manage Templates',
      href: '/manage-templates',
      icon: Settings,
    }
  ] : [];

  // Combine regular navigation with admin navigation
  const allNavigation = [...navigation, ...adminNavigation];

  return (
    <div 
      className={clsx(
        'fixed left-0 top-16 md:top-20 bottom-0 w-64 bg-ag-black-700 border-r border-ag-black-400 overflow-y-auto z-40 transition-transform duration-300 ease-in-out',
        // Mobile: slide in/out from left
        'lg:translate-x-0',
        isOpen ? 'translate-x-0' : '-translate-x-full'
      )}
    >
      {/* Close button for mobile */}
      <div className="lg:hidden flex justify-end p-3 border-b border-ag-black-400">
        <button
          onClick={onClose}
          className="p-2 text-gray-400 hover:text-white hover:bg-ag-black-600 rounded-lg transition-colors"
          aria-label="Close sidebar"
        >
          <X size={20} />
        </button>
      </div>
      
      <nav className="p-4 space-y-2">
        {allNavigation.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = item.icon;
          
          return (
            <Link
              key={item.name}
              to={item.href}
              onClick={onClose}
              className={clsx(
                'flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-ag-green/10 text-ag-green border-r-2 border-ag-green'
                  : 'text-gray-400 hover:bg-ag-black-600 hover:text-white'
              )}
            >
              <Icon
                size={20}
                className={clsx(
                  'mr-3',
                  isActive ? 'text-ag-green' : 'text-gray-500'
                )}
              />
              {item.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;